import AuthProvider from "../Auth/authProviders/authProvider";

const authProviderConfig = [new AuthProvider()];

export default authProviderConfig;
